import clsx, {ClassValue} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

type Styles = {
  [name: string]: ClassValue;
};

export type StyleProps<T extends Styles> = {
  [name in keyof T]?: boolean;
};

const extendedTwMerge = extendTailwindMerge({
  extend: {
    theme: {
      // ... extend theme, optional
    },
  },
});

export const cn = (...inputs: ClassValue[]) => {
  return extendedTwMerge(clsx(inputs));
};

export const formatClassName = <T extends {[name: string]: unknown}>(
  styles: Styles,
  props: T,
  className?: string,
) => {
  const classes = Object.keys(props).reduce<ClassValue[]>((acc, key) => {
    if (styles[key]) {
      if (props[key]) {
        acc.push(styles[key]);
      }
      delete props[key];
    }

    return acc;
  }, []);

  return cn(classes, className);
};
